module.exports = __webpack_public_path__ + "static/img/accounts.4c390328.png";